// ** api slice imports
import { slices } from '../../app/slice';

const routes = {
  GET_ALL_NOTIFICATIONS: '/notifications',
  GET_NOTIFICATION_BY_ID: '/notifications/:id',
  CREATE_NOTIFICATION: '/notifications',
  UPDATE_NOTIFICATION: '/notifications/:id',
  DELETE_NOTIFICATION: '/notifications/:id',
  MARK_ALL_NOTIFICATIONS_AS_READ: '/notifications/mark-all-as-read',
  MARK_NOTIFICATION_AS_READ: '/notifications/:id/read',
  SEND_BROADCAST_NOTIFICATION: '/notifications/broadcast',
};

// ** slice for notifications
const notificationApiSlice = slices.injectEndpoints({
  endpoints: builder => ({
    getAllNotifications: builder.query({
      query: query => ({
        url: routes.GET_ALL_NOTIFICATIONS,
        params: query,
      }),
      keepUnusedDataFor: 0,
      refetchOnMountOrArgChange: true,
    }),
    getNotificationById: builder.query({
      query: id => ({
        url: routes.GET_NOTIFICATION_BY_ID.replace(':id', id),
      }),
      keepUnusedDataFor: 0,
      refetchOnMountOrArgChange: true,
    }),
    createNotification: builder.mutation({
      query: data => ({
        url: routes.CREATE_NOTIFICATION,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Notifications'],
    }),
    updateNotification: builder.mutation({
      query: ({ id, data }) => ({
        url: routes.UPDATE_NOTIFICATION.replace(':id', id),
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['Notifications'],
    }),
    deleteNotification: builder.mutation({
      query: ({ id }) => ({
        url: routes.DELETE_NOTIFICATION.replace(':id', id),
        method: 'DELETE',
      }),
      invalidatesTags: ['Notifications'],
    }),
    markAllNotificationsAsRead: builder.mutation({
      query: () => ({
        url: routes.MARK_ALL_NOTIFICATIONS_AS_READ,
        method: 'PATCH',
      }),
      invalidatesTags: ['Notifications'],
    }),
    markNotificationAsRead: builder.mutation({
      query: ({ id }) => ({
        url: routes.MARK_NOTIFICATION_AS_READ.replace(':id', id),
        method: 'PATCH',
      }),
      invalidatesTags: ['Notifications'],
    }),
    sendBroadcastNotification: builder.mutation({
      query: data => ({
        url: routes.SEND_BROADCAST_NOTIFICATION,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Notifications'],
    }),
  }),
});

export const {
  useGetAllNotificationsQuery,
  useGetNotificationByIdQuery,
  useCreateNotificationMutation,
  useUpdateNotificationMutation,
  useDeleteNotificationMutation,
  useMarkAllNotificationsAsReadMutation,
  useMarkNotificationAsReadMutation,
  useSendBroadcastNotificationMutation,
} = notificationApiSlice;
